import React, { useEffect, useState, useSyncExternalStore } from 'react';
import { Button, Col, Drawer, Form, Modal, Row } from "antd";
import ManutencaoPlanoContaContabil from "./manutencao";
import { useForm } from 'antd/es/form/Form';

import { drawerActions, listagemActions, manutencaoActions } from '../../actions';
import { useStateValue } from '../../state';
import { CloseOutlined, ExclamationCircleOutlined, MinusOutlined, SaveOutlined } from '@ant-design/icons';
import ManutencaoPedidos from '../pedidos/manutencao';
import PlanoContaContabil from '.';

export default function DrawerPlanoContabil({ editando, setEditando, openDrawer, setOpenDrawer, atualizarLista }) {

    const [formPlanoContaContabil] = Form.useForm();
    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [carregando, setCarregando] = useState(false);

    useEffect(() => {
        console.log(manutencao.dados);
        if (openDrawer) {
          
            if (manutencao?.dados && editando) {
                const dadosTratados = limparZeros(manutencao.dados);
                formPlanoContaContabil.setFieldsValue({
                    ...manutencao.dados,
                    pcc_analiticosintetico: Number(manutencao.dados.pcc_analiticosintetico),
                });
            } else {
                formPlanoContaContabil.resetFields();
                dispatch({ type: manutencaoActions.CHANGE, data: {dados: null}});
            }
        }
    }, [openDrawer]);

    function fecharDrawer() {
        formPlanoContaContabil.resetFields();
        dispatch({ type: manutencaoActions.CHANGE, data: { dados: null } });
        dispatch({ type: drawerActions.CHANGE, data: { showDrawer: false } });
        dispatch({ type: listagemActions.CHANGE, data: { ordem: '+pcc_descricao' } });
        setOpenDrawer(false);
        setEditando(false);
    }

    const onClose = () => {
        Modal.confirm({
            title: 'Cancelar?',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja cancelar a operação e ignorar o que foi realizado até o momento?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                fecharDrawer();
            }
        });
    }

    const limparZeros = (data) => {
        return Object.fromEntries(
          Object.entries(data).filter(([_, value]) => value !== null && value !== undefined)
        );
      };

    return (
        <Drawer 
            title="Alteração de Registros"
            width="60%"
            open={openDrawer}
            limparAoEditar={true}
            fecharDrawer={() => { fecharDrawer() }}
            closeIcon={<MinusOutlined />}
            footer={
                <div>
                    <Row align="middle" justify="end" gutter={[8, 0]}>
                        <Col>
                            <Button onClick={onClose} icon={<CloseOutlined />} size="large" htmlType="button">
                                Cancelar
                            </Button>
                        </Col>
                        <Col>
                            <Button onClick={() => formPlanoContaContabil.submit()} loading={carregando} icon={<SaveOutlined />} size="large" type="primary">
                                Salvar
                            </Button>
                        </Col>
                    </Row>
                </div>
            }>
            <ManutencaoPlanoContaContabil formulario={formPlanoContaContabil} carregando={setCarregando} aoSalvar={(data) => { fecharDrawer(); }} editando={editando} atualizarLista={atualizarLista()} />
        </Drawer>
    )
}